import { apiClient } from '@/to-fsd/shared/api';

export const prmService = {
  /**
   * Get prm app data
   *
   * @return {Promise}
   * @throws {Error}
   */
  getPrmApp() {
    return apiClient.get('/merchant/merchant/app');
  },
};
